/**
 * Removes empty address fields
 *
 * **Note:** This function does not mutate `address`.
 *
 * @param {Object} address
 * @returns address without falsy values
 */
function sanitizeAddress(address) {
  if (!address) return

  const sanitizedAddress = {}

  for (const key in address) {
    const value = address[key]
    if (value) {
      sanitizedAddress[key] = value
    }
  }

  return sanitizedAddress
}

export default sanitizeAddress
